import { createContext } from 'react'

const GlobalContext = createContext({
  isLoaded: false,
  isLargeScreen: false,
})

export default GlobalContext
